import React from 'react';
import { TruckIntro } from './truck';
import useTruckTheme from './truck/useTruckTheme';

// Fullskjerm-splash ved appstart: vises mens innloggingsstatus lastes, og minst så lenge at
// intro-animasjonen rekker å tegnes ferdig (se SPLASH_MIN_MS i AuthContext).
export default function AppSplash() {
  const theme = useTruckTheme();
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--color-bg)',
    }}>
      <TruckIntro size={160} theme={theme} />
    </div>
  );
}
